<ng-container *ngIf="data?.Promotions?.length">
 <ng-container *ngFor="let item of data.Promotions">
  <!-- فعلا اینو شرطی میزاریم چون فقط واسه شب رایگان میخوایمش -->
  <div
   *ngIf="item.Code === hotelLabelEnum.free_night" (click)="onItemClick.emit(true)"
   class="bg-red-50 flex items-center justify-between w-full p-2 text-sm rounded-md overflow-hidden gap-3 lg:max-w-full mb-2 cursor-pointer">
   <div class="flex items-center">
    <em
     class="bg-white text-red-400 font-semi-bold px-2 py-1 whitespace-nowrap"
     style="font-style: normal; border-radius: 4px"
     >{{ item.Title }}</em
    >

    <p class="text-black-400 ml-2 overflow-hidden text-xs mr-2">
     {{ item.Description }}
    </p>
   </div>

   <div class="flex items-center gap-4">
    <iho-count-down *ngIf="item.CountdownTimer" [Dates]="item.CountdownTimer" />
   </div>
  </div>
 </ng-container>
</ng-container>
